module.exports = __webpack_public_path__ + "static/media/0.fc5aa9a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/400/0.png
// module id = 139
// module chunks = 0